module.exports = __webpack_public_path__ + "img/STERiGLIDE_02_08.8ab041fb.jpg";